export const formatDate = (dateString: string | null | undefined) => {
  if (!dateString) {
    return ""; // or any default value you prefer
  }

  // Parse the date string into a Date object
  const date = new Date(dateString);

  // Array of month names
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Array of day names
  const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  // Get the day, month, and year
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const month = monthNames[monthIndex];
  const year = date.getFullYear();

  // Get the day of the week
  const dayIndex = date.getDay();
  const dayOfWeek = dayNames[dayIndex];

  // Construct the formatted date string
  const formattedDate = `${dayOfWeek}, ${month} ${day} ${year}`;

  return formattedDate;
};
